export default __webpack_public_path__ + "static/media/keto-bars-box.a301cfeb.png";